import { FC, MouseEvent, PropsWithChildren, useRef } from "react";

import { TDrawerCloseFunction } from "@ryde/shared";

import { MenuDrawerBackdropStyled } from "./menu-backdrop.styled";

interface IMenuDrawerBackdropProps extends PropsWithChildren {
  onCloseDrawer: TDrawerCloseFunction;
}

export const MenuDrawerBackdrop: FC<IMenuDrawerBackdropProps> = ({
  onCloseDrawer,
  children,
}) => {
  const backdropRef = useRef(null);

  const onClick = (event: MouseEvent): void => {
    event.stopPropagation();

    if (event.target !== backdropRef.current) {
      return;
    }

    onCloseDrawer();
  };

  return (
    <MenuDrawerBackdropStyled ref={backdropRef} onClick={onClick}>
      {children}
    </MenuDrawerBackdropStyled>
  );
};
